/**
 * @file 反馈页
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from '../../components/banner/Banner';
import ContactList from './components/contacts-list/ContactsList';

import FeedbackForm from './components/feedback-form/FeedbackForm';
import useFeedbackStore from './feedbackHooks';


const Feedback: React.FC = () => {
    const {
        verifyCodeImg,
        verifyCodeLoading,

        feedbackForm,
        getVerifyCode,
        submit
    } = useFeedbackStore();

    return (
        <div className="page paddle-feedback-page">
            <Header />
            <Banner
                title="联系与反馈"
                subtitle="感谢您对飞桨的关注，您在使用过程中产生的任何问题和建议，都可以通过下方反馈渠道告诉我们，飞桨团队会认真对待每个开发者的意见"
                divider
            />
            <div className="paddle-feedback-page-container">
                <div className="paddle-context-h2">
                    问题反馈
                </div>

                <FeedbackForm
                    verifyCodeImg={verifyCodeImg}
                    verifyCodeLoading={verifyCodeLoading}
                    getVerifyCode={getVerifyCode}
                    form={feedbackForm}
                    submit={submit}
                />

                <div className="paddle-context-h2">
                    您也可以选择以下方式
                </div>

                <ContactList />
            </div>
            <Footer />
        </div>
    );
};

export default Feedback;
